import { combineReducers } from "redux";

import userSessionReducer from "./userSession/userSession.slice";


export default combineReducers({
    userSession: userSessionReducer
});